<template>
  <div class="ftp">
    <div class="ftp-inner" :style="{minHeight: contentHeight}">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in titleList" :key="index">
          <span class="crumb_span" @click="jump(item.name, index)">{{item.name}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="title">
        FTP
      </div>
      <ul>
        <li v-for="(item, index) in itemList" :key="index">
          <el-row :gutter="20">
            <el-col :span="8">
              <span class="span-name" @click="nextLevel(item.value, item.is_file, item.file_path)">{{item.label}}
                <span v-if="!item.is_file">/</span>
              </span>
            </el-col>
            <el-col :span="8" style="text-align:center;">
              <span style="color:#666;font-size:14px;">{{item.file_time}}</span>
            </el-col>
            <el-col :span="8" style="text-align:right;">
              <span style="color:#666;padding-right:20px;font-size:14px;">{{item.file_size}}</span>
            </el-col>
          </el-row>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
let url = {
  download_ftp: "user/download_ftp"
}
export default {
  name: "ftp",
  data() {
    return {
      contentHeight: (window.innerHeight - 510) + 'px',
      titleList: [
        {
          name: 'FTP'
        }],
      itemList: [],
      noClick: true
    };
  },
  mounted() {
    this.getList('')
  },
  methods: {
    getList(val) {
      this.http.get(url.download_ftp, { 'file_name': val }).then(res => {
        if (res.data.code == 200) {
          this.itemList = res.data.data;
          this.noClick = true
        }
      }).catch(err => {
        this.$message.warning(err.data.msg);
      });
    },
    nextLevel(val, is_file, file_path) {
      if (this.noClick) {
        // 第一次点击时执行
        this.noClick = false
        if (is_file) {// 下载
          window.open(file_path, '_blank')
          this.noClick = true
        } else {
          this.titleList.push({
            name: val
          })
          let params = ''
          this.titleList.forEach((item, index) => {
            if (index > 0) {
              params += item.name + '/'
            }
          })
          this.getList(params)
        }
      }
    },
    jump(name, i) {
      if (this.titleList.length > 1 && i != this.titleList.length - 1) {
        if (i > 0) {
          this.titleList.forEach((item, index) => {
            if (index >= i) {
              this.titleList.pop()
            }
          })
          let params = ''
          this.titleList.forEach((item, index) => {
            if (index > 0) {
              params += item.name + '/'
            }
          })
          this.getList(params)
        } else {
          this.getList('')
          this.titleList = [
            {
              name: 'FTP'
            }]
        }
      }
    }
  }
};
</script>

<style scoped>
.ftp {
  width: 100%;
  padding: 40px 0px;
  background: #f5f9fc;
}
.ftp .el-breadcrumb {
  position: absolute;
  top: -40px;
  left: 20px;
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC Medium, PingFang SC Medium-Medium;
  font-weight: 500;
  color: #333;
  line-height: 40px;
}
.ftp .el-breadcrumb span {
  color: #333;
  cursor: pointer;
}
.ftp .el-breadcrumb .el-breadcrumb__item:last-child span {
  color: #999 !important;
}
.ftp .ftp-inner {
  position: relative;
  width: 1200px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.ftp .ftp-inner .title {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
  border-bottom: 1px solid #d7d9db;
  overflow: hidden;
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.ftp .ftp-inner li {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e7e7e7;
}
.ftp .ftp-inner li .span-name {
  cursor: pointer;
  /* text-decoration: underline; */
  color: #8bb644;
  padding-left: 20px;
  font-size: 14px;
}
.ftp >>> .el-breadcrumb__separator {
  color: #333;
}
</style>
